// extracted by mini-css-extract-plugin
export var legendIndicator = "_gg-1";
export var legendRight = "_gg-0";